import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import CasemanagerAttachmentTab from './casemanagerAttachments/CasemanagerAttachments';

import { setRemoveAllAttachmentsFlag } from '../../../../../slices/piiRemovalSlice';
import { RootState } from '../../../../../utils/store';
import AttachmentTab from '../attachments/attachments';

const buttonStyle = {
  fontFamily: 'Schibsted Grotesk',
  color: 'gray',
  fontSize: '.9rem',
  fontWeight: 500,
  textTransform: 'none',
  borderRadius: '6px 0px 0px 0px',
  height: '52px',
  '& .MuiButtonBase-root-MuiButton-root:hover': {
    color: '#00CECF',
  },
};
const componentTabs = ['whistleblower', 'casemanager'];

const AttachmentsIndex = () => {
  const [selectedTab, setSelectedTab] = useState(componentTabs[0]);
  const tabsRef = useRef<HTMLDivElement>(null);
  const { piiRemovalFlag, attachmentsEmptyFlag } = useSelector(
    (state: RootState) => state.piiRemoval,
  );
  const dispatch = useDispatch();
  const scrollToBottom = () => {
    tabsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const changeTabHandler = (tab: string) => {
    setSelectedTab(tab);
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  };

  const removeAllAttachmentsClick = () => {
    dispatch(setRemoveAllAttachmentsFlag(true));
  };

  return (
    <Box sx={{ pl: 2.5, pr: 2.5, pb: 2.5, minHeight: '500px' }}>
      <Stack
        direction={{
          lg: 'row',
          md: 'column',
          sm: 'column',
          xs: 'column',
        }}
      >
        {/* Attachement */}
        <Button
          sx={{
            ...buttonStyle,
            color: selectedTab === componentTabs[0] ? '#00CECF' : 'gray',
            background: 'transparent',
            borderBottom:
              selectedTab === componentTabs[0] ? '2px solid #00CECF' : 'none',
          }}
          onClick={() => changeTabHandler(componentTabs[0])}
        >
          <FormattedMessage defaultMessage='Reporter' />
        </Button>
        {/* Messgaes */}
        <Button
          sx={{
            ...buttonStyle,
            color: selectedTab === componentTabs[1] ? '#00CECF' : 'gray',
            background: 'transparent',
            borderBottom:
              selectedTab === componentTabs[1] ? '2px solid #00CECF' : 'none',
          }}
          onClick={() => changeTabHandler(componentTabs[1])}
        >
          <FormattedMessage defaultMessage='Case Manager' />
        </Button>

        {piiRemovalFlag === true && attachmentsEmptyFlag === false ? (
          <Button
            onClick={removeAllAttachmentsClick}
            sx={{ width: 'auto', marginLeft: 'auto' }}
          >
            <Typography
              sx={{
                color: 'red',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'Schibsted Grotesk',
              }}
            >
              <FormattedMessage defaultMessage='Remove all attachments' />
            </Typography>
          </Button>
        ) : (
          ''
        )}
      </Stack>
      <Divider />
      <Box
        sx={{
          height: 'auto',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          '::-webkit-scrollbar': {
            width: '10px',
          },
          '::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '::-webkit-scrollbar-thumb': {
            bgcolor: 'rgba(155, 155, 155, 0.5)',
            borderRadius: '20px',
            border: 'transparent',
          },
        }}
        ref={tabsRef}
      >
        <Box display={selectedTab === componentTabs[0] ? '' : 'none'}>
          <AttachmentTab />
        </Box>
        <Box display={selectedTab === componentTabs[1] ? '' : 'none'}>
          <CasemanagerAttachmentTab />
        </Box>
      </Box>
    </Box>
  );
};

export default AttachmentsIndex;
